<div class="row position-relative">
    <form (submit)="submitForm()">
        <div class="col-12 position-relative">
            <div class="form-group row mb-3">
                <label for="customer-name" class="col-sm-3 col-form-label required">Kundenavn</label>
                <div class="col-sm-8">
                    <input spellcheck="false" type="text" class="form-control" id="customer-name"
                        [formField]="customerForm.customerName" autocomplete="off" autofocus>
                    @if (customerForm.customerName().invalid() && customerForm.customerName().touched()) {
                    <div class="error-feedback">
                        @for (error of customerForm.customerName().errors(); track error.kind) { <span>{{ error.message }}</span> }
                    </div>
                    }
                </div>
            </div>
            <div class="form-group row mb-3">
                <label for="name" class="col-sm-3 col-form-label required">Vist navn</label>
                <div class="col-sm-8">
                    <input spellcheck="false" type="text" class="form-control" id="name"
                        [formField]="customerForm.name" autocomplete="off">
                    @if (customerForm.name().invalid() && customerForm.name().touched()) {
                    <div class="error-feedback">
                        @for (error of customerForm.name().errors(); track error.kind) { <span>{{ error.message }}</span> }
                    </div>
                    }
                </div>
            </div>
            <div class="form-group row mb-3">
                <label for="customer-email" class="col-sm-3 col-form-label required">Kunde E-Mail</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="customer-email"
                        [formField]="customerForm.email" autocomplete="off">
                    @if (customerForm.email().invalid() && customerForm.email().touched()) {
                    <div class="error-feedback">
                        @for (error of customerForm.email().errors(); track error.kind) { <span>{{ error.message }}</span> }
                    </div>
                    }
                </div>
            </div>
            <div class="form-group row mb-3">
                <label for="customer-date" class="col-sm-3 col-form-label required">Dato for idriftsættelse</label>
                <div style="width: fit-content; min-width: 100px;">
                    <input type="date" placeholder="dd-mm-yyyy" class="form-control" id="customer-date"
                        [formField]="customerForm.productionDate" autocomplete="off">
                    @if (customerForm.productionDate().invalid() && customerForm.productionDate().touched()) {
                    <div class="error-feedback">
                        @for (error of customerForm.productionDate().errors(); track error.kind) { <span>{{ error.message }}</span> }
                    </div>
                    }
                </div>
            </div>
            <div class="form-group row mb-5">
                <label for="customer-ev-license" class="col-sm-3 col-form-label" [class.required]="evLicenseRequired()">EV Licens</label>
                <div class="col-sm-8">
                    <div class="form input-group">
                    <input type="text" class="form-control" id="customer-ev-license"
                        [formField]="customerForm.evLicense" autocomplete="off">
                        <i class="ms-2 mt-2 fa-regular fa-circle-question" ngbTooltip="Kontakt administrationen for at få en licens til kunden." ></i>
                    </div>                        
                    @if (customerForm.evLicense().invalid() && customerForm.evLicense().touched()) {
                    <div class="error-feedback">
                        @for (error of customerForm.evLicense().errors(); track error.kind) { <span>{{ error.message }}</span> }
                    </div>
                    }
                </div>
            </div>
            <div class="form-group row mb-5">
                <label for="customer-licenses" class="col-sm-3 col-form-label">Forventet antal brugere</label>
                <div style="width: 125px;">
                    <input type="text" class="form-control text-end" id="customer-licenses"
                        inputmode="numeric" [formField]="customerForm.numberOfLicenses" autocomplete="off">
                </div>
            </div>
            <div class="form-group row mb-3">
                <label class="col-sm-3 col-form-label required" for="consultant-kunde">Kundeansvarlig</label>
                <div class="col-sm-8">
                    @if(consultantsResource.isLoading()) {
                    <div class="form-control text-center">
                        <i class="fa-solid fa-spinner-third fa-spin"></i>
                    </div>
                    } @else {
                    <select class="form-select" id="consultant-kunde" [formField]="customerForm.customerResponsibleId">
                        @for (option of consultantsResource.hasValue() ? consultantsResource.value() : []; track option.id) {
                        <option [disabled]="option.id === ''" [value]="option.id">
                            {{ option.id === '' ? option.name : option.name + '- [' + option.email + ']' }}
                        </option>
                        }
                    </select>
                    @if(customerForm.customerResponsibleId().invalid() && customerForm.customerResponsibleId().touched()) {
                    <div class="error-feedback">
                        @for (error of customerForm.customerResponsibleId().errors(); track error.kind) { <span>{{ error.message }}</span> }
                    </div>
                    }
                    }
                </div>
            </div>
            <div class="form-group row mb-3">
                <label class="col-sm-3 col-form-label required" for="consultant-drift">Driftansvarlig</label>
                <div class="col-sm-8">
                    @if(consultantsResource.isLoading()) {
                    <div class="form-control text-center">
                        <i class="fa-solid fa-spinner-third fa-spin"></i>
                    </div>
                    } @else {
                    <select class="form-select" id="consultant-drift" [formField]="customerForm.productionResponsibleId">
                        @for (option of consultantsResource.hasValue() ? consultantsResource.value() : []; track option.id) {
                        <option [disabled]="option.id === ''" [value]="option.id">
                            {{ option.id === '' ? option.name : option.name + '- [' + option.email + ']' }}
                        </option>
                        }
                    </select>
                    @if(customerForm.productionResponsibleId().invalid() && customerForm.productionResponsibleId().touched()) {
                    <div class="error-feedback">
                        @for (error of customerForm.productionResponsibleId().errors(); track error.kind) { <span>{{ error.message }}</span> }
                    </div>
                    }
                    }
                </div>
            </div>
            <div class="form-group row mb-1">
                <label class="col-sm-3 col-form-label required" for="consultant-implementation">Implement.ansvarlig</label>
                <div class="col-sm-8">
                    @if(implementationConsultantsResource.isLoading()) {
                    <div class="form-control text-center">
                        <i class="fa-solid fa-spinner-third fa-spin"></i>
                    </div>
                    } @else {
                    <select class="form-select" id="consultant-implementation"
                        [formField]="customerForm.implementationResponsibleId">
                        @for (option of implementationConsultantsResource.hasValue() ? implementationConsultantsResource.value() : []; track option.id) {
                        <option [disabled]="option.id === ''" [value]="option.id">
                            {{ option.id === '' ? option.name : option.name + '- [' + option.email + ']' }}
                        </option>
                        }
                    </select>
                    }
                </div>
            </div>
            <div class="form-group row mb-3 position-relative">
                <div class="col-sm-3"></div>
                <div class="col-sm-8">
                    <button ngbTooltip="Vælg fra andre afdelinger" class="btn btn-primary" type="button"
                        style="max-width: 500px; width: 100%;" (click)="showEmployeesModal()" aria-expanded="false">
                        <i class="fa-solid fa-user-plus"></i>
                    </button>
                    @if(customerForm.implementationResponsibleId().invalid() && customerForm.implementationResponsibleId().touched()) {
                    <div class="error-feedback">
                        @for (error of customerForm.implementationResponsibleId().errors(); track error.kind) { <span>{{ error.message }}</span> }
                    </div>
                    }
                </div>
            </div>
            @if (customer().createdBy) {
            <div class="form-group row mb-5">
                <label class="col-sm-3 col-form-label" for="customer-createdby">Oprettet af</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="customer-createdby"
                        [value]="customer().createdBy" autocomplete="off" readonly>
                </div>
            </div>
            }
            <div class="form-group row mb-3">
                <label class="col-3 col-form-label" for="culture-names">Standardsprog</label>
                <div class="col-8">
                    <select class="form-select" id="culture-names" [formField]="customerForm.cultureCode"
                        (change)="onCultureChange($event)">
                        @for (culture of cultures(); track culture.key) {
                        <option [value]="culture.key">
                            {{ culture.key }} - [{{ culture.value }}]
                        </option>
                        }
                    </select>
                </div>
            </div>
            <div class="form-group row mb-3">
                <label class="col-sm-3 col-form-label text-end-sm-start" for="culture-available">Tilgængelige</label>
                <div class="col-sm-8">
                    <div style="height: 117px; overflow-y: auto;">
                        @for (culture of cultures(); track culture.key) {
                        <div class="form-check ms-1">
                            <input class="form-check-input" type="checkbox" id="culture{{$index}}"
                                [checked]="culture.selected"
                                (change)="onCultureCheckboxChange(culture, $event)"
                                [disabled]="formModel().cultureCode === culture.key">
                            <label class="form-check-label" for="culture{{$index}}">{{ culture.key }} - [{{ culture.value }}]</label>
                        </div>
                        }
                    </div>
                </div>
            </div>
            @if(hasStorageError()) {
            <div class="alert alert-danger mb-3" role="alert">
                {{ errorMessage()?.message }}
            </div>
            }
            <div class="accordion mb-4" id="storageSettingsAccordion">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingStorage">
                        <button class="accordion-button" [class.collapsed]="!storageOpen()" type="button"
                            (click)="toggleStorage()" [attr.aria-expanded]="storageOpen()"
                            aria-controls="collapseStorage">
                            <span class="d-flex align-items-center gap-2" [class.required]="AzureValidationRequired()"
                                style="width: 300px;">
                                <span>Generel Azure Storage</span>
                                <span class="flex-grow-1 border-top border-dark opacity-75"></span>
                                <span>Indstillinger</span>
                            </span>
                        </button>
                    </h2>
                    <div id="collapseStorage" class="accordion-collapse collapse" aria-labelledby="headingStorage"
                        data-bs-parent="#storageSettingsAccordion" [class.show]="storageOpen()">
                        <div class="accordion-body">
                            @if(isDevEnv()) {
                            <div class="form-group row mb-3">
                                <div class="form-check form-switch mb-4 offset-sm-3">
                                    <input class="form-check-input" type="checkbox" id="skipAzureValidation"
                                        [checked]="skipAzureValidation()"
                                        (change)="onToggleSkipAzure($any($event.target).checked)">
                                    <label class="form-check-label" for="skipAzureValidation">
                                        (for dev/test, ignorer azure connection)
                                    </label>
                                </div>
                            </div>
                            }
                            <div class="alert alert-info mb-3" role="alert">
                                <strong>Bemærk:</strong> Husk at konfigurere CORS (Cross-Origin Resource Sharing) på din
                                Azure Storage konto for at sikre korrekt funktionalitet.<br>
                                <a href="https://learn.microsoft.com/en-us/azure/developer/javascript/tutorial/browser-file-upload-azure-storage-blob?tabs=github-codespaces#configure-storage-cors"
                                    target="_blank" rel="noopener">
                                    Læs mere om opsætning af CORS på Azure Storage, følg trin 2-4 i "Configure Storage CORS"
                                </a>
                                <br><br>
                                <strong>Bemærk:</strong> "Connectionstring" findes i Azure Portal under Storage Account
                                -> Security + networking -> Access keys -> Connection string.
                                <br>
                            </div>
                            <div class="form-group row mb-3">
                                <label for="container-name" class="col-sm-3 col-form-label"
                                    [class.required]="AzureValidationRequired()">Container Name</label>
                                <div class="col-sm-8">
                                    <div class="input-group mb-2">
                                        <input type="text" class="form-control" id="container-name"
                                            [formField]="customerForm.storage.containerName" autocomplete="off">
                                        <button class="btn btn-outline-secondary" type="button"
                                            (click)="checkStorageContainer(customerForm.storage.connectionString().value(), customerForm.storage.containerName().value())"
                                            [disabled]="customerForm.storage.connectionString().invalid() || !customerForm.storage.connectionString().value()"
                                            ngbTooltip="test forbindelse til azure storage">
                                            @if(testingStorageConnection()) {
                                            <i class="fa-solid fa-spinner-third fa-spin"></i>
                                            } @else {
                                            <i class="fa-solid fa-check"></i>
                                            }
                                        </button>
                                    </div>
                                    @if(customerForm.storage.containerName().invalid() && customerForm.storage.containerName().touched()) {
                                    <div class="error-feedback">
                                        @for (error of customerForm.storage.containerName().errors(); track error.kind) { <span>{{ error.message }}</span> }
                                    </div>
                                    }
                                </div>
                            </div>
                            <div class="form-group row mb-3">
                                <label for="connection-string" class="col-sm-3 col-form-label"
                                    [class.required]="AzureValidationRequired()">Connectionstring</label>
                                <div class="col-sm-8">
                                    <div class="input-group mb-2">
                                        <input [type]="showStorageConnectionString() ? 'text' : 'password'"
                                            class="form-control" id="connection-string"
                                            [formField]="customerForm.storage.connectionString" autocomplete="off">
                                        <button class="btn btn-outline-secondary" type="button"
                                            (click)="toggleShowStorageConnectionString()"
                                            ngbTooltip="vis/skjul connectionstreng">
                                            @if(showStorageConnectionString()) {
                                            <i class="fa-solid fa-eye-slash"></i>
                                            } @else {
                                            <i class="fa-solid fa-eye"></i>
                                            }
                                        </button>
                                        <button class="btn btn-outline-secondary" type="button"
                                            (click)="testStorageConnection(customerForm.storage.connectionString().value())"
                                            [disabled]="customerForm.storage.connectionString().invalid() || !customerForm.storage.connectionString().value()"
                                            ngbTooltip="test forbindelse til azure storage">
                                            @if(testingStorageConnection()) {
                                            <i class="fa-solid fa-spinner-third fa-spin"></i>
                                            } @else {
                                            <i class="fa-solid fa-plug"></i>
                                            }
                                        </button>
                                    </div>
                                    @if(customerForm.storage.connectionString().invalid() && customerForm.storage.connectionString().touched()) {
                                    <div class="error-feedback">
                                        @for (error of customerForm.storage.connectionString().errors(); track error.kind) { <span>{{ error.message }}</span> }
                                    </div>
                                    }
                                </div>
                            </div>
                            @if(customerForm.storage().errors().length) {
                            <div class="error-feedback ms-sm-3">
                                @for (error of customerForm.storage().errors(); track error.kind) { <span>{{ error.message }}</span> }
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            @if(hasPersonalStorageError()) {
            <div class="alert alert-danger mb-3" role="alert">
                {{ errorMessage()?.message }}
            </div>
            }
            <div class="accordion mb-4" id="personalStorageSettingsAccordion">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingPersonalStorage">
                        <button class="accordion-button" [class.collapsed]="!personalStorageOpen()" type="button"
                            (click)="togglePersonalStorage()" [attr.aria-expanded]="personalStorageOpen()"
                            aria-controls="collapsePersonalStorage">
                            <span class="d-flex align-items-center gap-2" style="width: 300px;">
                                <span>Privat Azure Storage</span>
                                <span class="flex-grow-1 border-top border-dark opacity-75"></span>
                                <span>Indstillinger</span>
                            </span>
                        </button>
                    </h2>
                    <div id="collapsePersonalStorage" class="accordion-collapse collapse"
                        aria-labelledby="headingPersonalStorage" data-bs-parent="#personalStorageSettingsAccordion"
                        [class.show]="personalStorageOpen()">
                        <div class="accordion-body">
                            <div class="alert alert-info mb-3" role="alert">
                                <strong>Bemærk:</strong> Husk at konfigurere CORS (Cross-Origin Resource Sharing) på din
                                Azure Storage konto for at sikre korrekt funktionalitet.<br>
                                <a href="https://learn.microsoft.com/en-us/azure/developer/javascript/tutorial/browser-file-upload-azure-storage-blob?tabs=github-codespaces#configure-storage-cors"
                                    target="_blank" rel="noopener">
                                    Læs mere om opsætning af CORS på Azure Storage, følg trin 2-4 i "Configure Storage CORS"
                                </a>
                                <br><br>
                                <strong>Bemærk:</strong> "Connectionstring" findes i Azure Portal under Storage Account
                                -> Security + networking -> Access keys -> Connection string.
                                <br>
                            </div>
                            <div class="form-group row mb-3">
                                <label for="personal-connection-string" class="col-sm-3 col-form-label">Connectionstring</label>
                                <div class="col-sm-8">
                                    <div class="input-group mb-2">
                                        <input [type]="showPersonalStorageConnectionString() ? 'text' : 'password'"
                                            class="form-control" id="personal-connection-string"
                                            [formField]="customerForm.personalStorage.connectionString" autocomplete="off">
                                        <button class="btn btn-outline-secondary" type="button"
                                            (click)="toggleShowPersonalStorageConnectionString()"
                                            ngbTooltip="vis/skjul connectionstreng">
                                            @if(showPersonalStorageConnectionString()) {
                                            <i class="fa-solid fa-eye-slash"></i>
                                            } @else {
                                            <i class="fa-solid fa-eye"></i>
                                            }
                                        </button>
                                        <button class="btn btn-outline-secondary" type="button"
                                            (click)="testStorageConnection(customerForm.personalStorage.connectionString().value())"
                                            [disabled]="customerForm.personalStorage.connectionString().invalid() || !customerForm.personalStorage.connectionString().value()"
                                            ngbTooltip="test forbindelse til azure storage">
                                            @if(testingStorageConnection()) {
                                            <i class="fa-solid fa-spinner-third fa-spin"></i>
                                            } @else {
                                            <i class="fa-solid fa-plug"></i>
                                            }
                                        </button>
                                    </div>
                                    @if(customerForm.personalStorage.connectionString().invalid() && customerForm.personalStorage.connectionString().touched()) {
                                    <div class="error-feedback">
                                        @for (error of customerForm.personalStorage.connectionString().errors(); track error.kind) { <span>{{ error.message }}</span> }
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
